// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_iq","advertCardHeader__actions":"c-a_ir","advertCardHeader__bottomLabel":"c-a_is"};